/**
 * LOS ESTADOS DE UN CONTEO TIENEN QUE SUMAR EL TOTAL (CONTEO-HISTORIAL-ESTADOS-T1 arreglo c; D #28829). Sin DOM.
 *
 * Caso real del 15-oct (presas): en el kiosko se desgloso 90 + 300 por estado; despues el total se edito plegado a 101
 * (o lo dejo el reconteo) y los estados se quedaron como estaban. Al enviar viajaron los dos: total 101 y estados que
 * suman 390. El Desktop confirmo 101 y los 390 nunca entraron al stock, pero la lectura los mostraba.
 *
 * Regla: el total que el operador deja es el que manda. Si los estados con filas no suman ese total, se vacian (no se
 * inventa un reparto) y no viajan. Si cuadran, viajan como siempre.
 *
 * Y la etiqueta del historial: una sesion con origen 'desktop' es lo CONFIRMADO (lo que el Desktop aplico); las demas
 * son el conteo del panel, PRELIMINAR (guia, no ajuste). Es la misma regla de la lectura de A (arreglo a), sin migrar.
 *
 * @module application/inventario/estadosDelConteo
 */

const lista = (o) => Object.values(o || {});

/** ¿Algun estado tiene filas? */
export function hayEstados(subConteos) {
  return lista(subConteos).some((e) => Array.isArray(e?.filas) && e.filas.length > 0);
}

/** La suma de los totales de los estados con filas. */
export function sumaDeEstados(subConteos) {
  return lista(subConteos).reduce((s, e) => s + (Array.isArray(e?.filas) && e.filas.length > 0 ? Number(e.total) || 0 : 0), 0);
}

/** ¿Los estados suman el total? (tolera redondeo de 0,001) */
export function estadosCuadran(contado, subConteos) {
  if (!hayEstados(subConteos)) return false;
  if (contado === null || contado === undefined || Number.isNaN(Number(contado))) return false;
  return Math.abs(sumaDeEstados(subConteos) - Number(contado)) < 0.001;
}

/** Los estados vacios, conservando el tipo de cada uno (simple o porcionado). */
export function vaciarEstados(subConteos) {
  const out = {};
  for (const [k, e] of Object.entries(subConteos || {})) out[k] = { filas: [], total: 0, tipo: e?.tipo || 'simple' };
  return out;
}

/**
 * Despues de que el total cambia por fuera de los estados (editado plegado o por el reconteo): si los estados ya no lo
 * suman, se vacian. Devuelve {subConteos, descartados}.
 */
export function ajustarEstadosAlTotal(contado, subConteos) {
  if (!hayEstados(subConteos) || estadosCuadran(contado, subConteos)) return { subConteos, descartados: false };
  return { subConteos: vaciarEstados(subConteos), descartados: true };
}

/** 'confirmado' si la sesion la escribio el Desktop; si no, 'preliminar' (conteo del panel). */
export function etapaDeSesion(sesion) {
  const d = sesion?.data && typeof sesion.data === 'object' ? sesion.data : sesion;
  const origen = String(d?.origen ?? sesion?.origen ?? '').toLowerCase();
  const rowId = String(sesion?.row_id ?? sesion?.rowId ?? d?.row_id ?? '');
  return origen === 'desktop' || rowId.startsWith('desk-verif') ? 'confirmado' : 'preliminar';
}

/** Cuenta las sesiones de un dia por etapa. */
export function contarPorEtapa(sesiones) {
  const r = { preliminar: 0, confirmado: 0 };
  for (const s of Array.isArray(sesiones) ? sesiones : []) r[etapaDeSesion(s)]++;
  return r;
}
